var _rect, _rect2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.2 0 12.4 11"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 0.75,
    x: 0.375,
    y: 1.875,
    stroke: "currentColor",
    rx: 0.375
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 0.75,
    x: 0.375,
    y: 7.875,
    stroke: "currentColor",
    rx: 0.375
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 2.25,
    r: 1.75,
    fill: "#fff",
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8.25,
    r: 1.75,
    fill: "#fff",
    stroke: "currentColor"
  })));
};
export default SvgFilter;